import { useState, useCallback } from "react"
import { IOmniaSession, IOmniaShell } from "@omnia/types"
import { IDashboardService } from "../types"
import { Card } from "@omnia/shared/react/Card"
import { useAsyncValue } from "@omnia/shared/react/hooks"
import { AreaNvz } from "./AreaNvz"
import { AreaNMax } from "./AreaNMax"

interface Props {
    svc: IDashboardService
    shell: IOmniaShell
    session: IOmniaSession
    update(run?: () => void): void
}

export function NvzCard({svc, session, update}: Props) {
    const [hasError, setHasError] = useState(false);

    const cardData = useAsyncValue(() => svc.ensureInit().then(() => {
        const nvz =  svc.getNutritionInfo();
        const fieldService = svc.getFieldService();
        const flds = fieldService.fields;
        
        return { 
            nvz: nvz, 
            fields: flds 
        };
    }), [svc, svc.yearId, svc.stateVersion]);

    const isReadOnly = session.isReadOnly(p => p.nutritionPlans);
    
    const handleErrorChange = useCallback((isError: boolean) => {
        setHasError(isError);
    }, []);

    const tools = (
        <div className="btn-group">
            {!isReadOnly &&
                <button className="btn btn-link btn-icon-toggle" onClick={() => svc.recalculateNMax()} title="Recalculate">
                    <i className="fas fa-sync-alt"></i>
                </button>
            }
        </div>
    );

    return <Card icon={hasError ? "icon icon-error" : ""} title="NVZ status" small={false} headerTools={tools} isCollapsible={true}>
        <AreaNvz className="section" holdingInNVZ={session.holding.NVZ} fields={cardData?.fields} />
        <AreaNMax className="section" svc={svc} nvz={cardData?.nvz} holding={session.holding} onErrorChange={handleErrorChange} />
    </Card>
}